<template>
  <div class="oilslist">
    <oils-list :allOrder='3'></oils-list>
  </div>
</template>
<script>
import OilsList from './oilsList';
export default {
  components:{
    OilsList,
  },
  data(){
    return{}
  }
}
</script>
<style lang="scss" scoped>
.oilslist{
  height: 100%;
  overflow: auto;
}
</style>